import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {


  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to api url
     const getToken : any = localStorage.getItem('token_clem_mobi');
    const isLoggedIn = getToken && getToken.access_token;
    if (isLoggedIn) {
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${getToken.access_token}`
            }
        });
    }

    return next.handle(request);
  }
}
